import { FC } from "react";
import { Vehicle } from "../../../types/Vehicle";
import Grid from "@mui/material/Grid";
import { Divider } from "@mui/material";
import { FuelType } from "../../../enum/fuelType.enum";
import { TableGrid } from "../../shared/TableGrid";
import { LabelHelper } from "../../../util/labelHelper";
import { appendQueryParam, getFormatteShortdDate, isMobile } from "../../../util/helper";
import { ListingType } from "../../../enum/vehicleListing.enum";
import { useBrands } from "../../../hooks/useBrands";
import { useModels } from "../../../hooks/useModels";
import { config } from "../../../config";
interface Props {
  vehicle: Vehicle;
  onSelect?: (v: Vehicle) => void;
  onUpdate?: (v: Vehicle) => void;
  onDelete?: (v: Vehicle) => void;
}
export const VehicleGridTable: FC<Props> = ({ vehicle, onSelect }) => {

  // TODO: Change fuel lable to KWH 
  const fuelLabel = vehicle.fuel === FuelType.Electric ? 'KWH Price' : 'Fuel Price';
  const desktop = !isMobile();
  const brands = useBrands();
  const models = useModels();
  const image1 = vehicle.images[config.thumbnailImageIndex];

  return (
    <Grid item xs={12} xl={9}>
      <Grid container sx={{ cursor: "pointer" }} onClick={() => { onSelect?.(vehicle) }} justifyContent="space-between">
        <TableGrid>
          <img style={{ 'height': '25px', 'width': '50px', objectFit: "contain"  }} src={appendQueryParam(image1, 'updatedAt', vehicle.updatedAt.toString()) ?? config.defaultVehicleImageUrl} />
        </TableGrid>
        <TableGrid>
          {vehicle.listing === ListingType.ListingForSale ? getFormatteShortdDate(vehicle.createdAt): LabelHelper.displayRegNo(vehicle.regNo)}
        </TableGrid>
        <TableGrid>
          {LabelHelper.getBrandLabelEntity(vehicle, brands)}
        </TableGrid>
        <TableGrid>
          {LabelHelper.getVehicleTypeLabel(vehicle.type)}
        </TableGrid>

        {/* Show only for desktop screens */}
        {desktop && <>
          <TableGrid>
            {vehicle.year}
          </TableGrid>
          
          <TableGrid>
            {LabelHelper.getModelLabelEntity(vehicle, models)}
          </TableGrid>

          <TableGrid>
            {vehicle.cc} CC
          </TableGrid>

          <TableGrid>
            {LabelHelper.getFuelTypeLabel(vehicle.fuel)}
          </TableGrid>

          <TableGrid>
            {vehicle.odo}km
          </TableGrid>
        </>}
      </Grid>
      <Divider />
    </Grid>
  );
};
